import { Component, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';

import { AuthService } from '@auth0/auth0-angular';

import { ToolbarComponent } from './modules/toolbar/toolbar.component';

@Component({
    imports: [RouterOutlet, ToolbarComponent],
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'xCF - Container xChange';
    auth = inject(AuthService);
    isAuthenticated = toSignal(this.auth.isAuthenticated$);

    constructor() {
        effect(() => {
            const isAuth = this.isAuthenticated();

            if (isAuth === false) {
                this.auth.getAccessTokenSilently().subscribe();
            }
        });
    }
}
